import { PERMISSION_DISPLAY } from './permission-display-metadata';

export class PermissionDefinitions {
  static readonly APP = 'iq';

  static readonly TILE_ADMIN_PORTAL_VIEW = 'iq.Tile.AdminPortal.VIEW';

  static readonly PATIENT_LIST_VIEW = 'iq.Patients.List.VIEW';
  static readonly PATIENT_LIST_WRITE = 'iq.Patients.List.WRITE';

  static readonly PROTOCOL_LIST_VIEW = 'iq.Protocol.List.VIEW';
  static readonly PROTOCOL_LIST_WRITE = 'iq.Protocol.List.WRITE';

  static readonly ACCOUNT_PROFILE_VIEW = 'iq.Account.Profile.VIEW';

  static readonly TREATMENT_PROFILE_DOCUMENTS_VIEW = 'iq.Treatment.Profile.Documents_VIEW';
  static readonly TREATMENT_PROFILE_DOCUMENTS_WRITE = 'iq.Treatment.Profile.Documents_WRITE';
  static readonly TREATMENT_PROFILE_DOCUMENTS_DELETE = 'iq.Treatment.Profile.Documents_DELETE';

  static readonly TREATMENT_PROFILE_CASES_VIEW = 'iq.Treatment.Profile.Cases_VIEW';
  static readonly TREATMENT_PROFILE_CASES_WRITE = 'iq.Treatment.Profile.Cases_WRITE';
  static readonly TREATMENT_PROFILE_CASES_SOAP_NOTES_VIEW = 'iq.Treatment.Profile.Cases_SOAP_NOTES_VIEW';
  static readonly TREATMENT_PROFILE_CASES_SOAP_NOTES_WRITE = 'iq.Treatment.Profile.Cases_SOAP_NOTES_WRITE';

  static readonly TREATMENT_PROFILE_REFERRALS_VIEW = 'iq.Treatment.Profile.Referrals_VIEW';
  static readonly TREATMENT_PROFILE_REFERRALS_WRITE = 'iq.Treatment.Profile.Referrals_WRITE';

  static readonly TREATMENT_PROFILE_RESULTS_VIEW = 'iq.Treatment.Profile.Results_VIEW';
  static readonly TREATMENT_PROFILE_TREAT = 'iq.Treatment.Profile.TREAT';
  static readonly TREATMENT_PROFILE_TREATMENT_REVIEW = 'iq.Treatment.Profile.TREATMENT_REVIEW';
  static readonly TREATMENT_PROFILE_TREATMENT_DUPLICATE = 'iq.Treatment.Profile.TREATMENT_DUPLICATE';
  static readonly TREATMENT_PROFILE_TREATMENT_RECALL = 'iq.Treatment.Profile.TREATMENT_RECALL';
  static readonly TREATMENT_PROFILE_TREATMENT_EDIT = 'iq.Treatment.Profile.TREATMENT_EDIT';
  static readonly TREATMENT_PROFILE_TREATMENT_PART_FINDINGS_WRITE = 'iq.Treatment.Profile.TREATMENT_PART_FINDINGS_WRITE';

  static readonly TREATMENT_ADJUST_ONLINE_ADJUST = 'iq.Treatment.Adjust.ONLINE_ADJUST';

  /** User-facing labels keyed by claim code. */
  static readonly DISPLAY = PERMISSION_DISPLAY;
}
